export enum EVariant {
  contained = 'contained',
  outlined = 'outlined',
  text = 'text',
}
